import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useRef } from "react";

export function ButtonMenu({label,icon,items,disabled,outlined,className,size})
{
    const menu = useRef(null);
    const icn = 'pi pi-chevron-down';//(icon==undefined?'pi pi-chevron-down':icon);
    return(
        <>
        <Menu model={items} popup ref={menu} className="w-auto"/>
        <Button className={className} text={!outlined} disabled={disabled} onClick={(event) => menu.current.toggle(event)} 
            outlined={outlined} icon={icon} size={size!=undefined?size:'normal'}>
            <div className="flex flex-row gap-2 align-items-baseline"><div className="pl-2">{label}</div><i className={icn+' text-sm'}/></div>
        </Button>	
        </>
    );
}